'use client'

import { useAnalytics } from '../hooks/useAnalytics'

// Starts Segment, and through it GTM, on routes that have no AnalyticsProvider of their
// own (admin login, unavailable tag, privacy page). The instance is a singleton, so on
// routes that do have one this is a no-op.
export function AnalyticsBootstrap() {
  useAnalytics()

  return null
}
